<div
  class="cookie-consent-popup"
  [class.show]="showPopup"
  role="region"
  aria-label="Cookie consent"
  [attr.aria-hidden]="!showPopup"
  [attr.inert]="!showPopup ? '' : null"
>
  <div class="cookie-consent-popup__content">
    <div class="cookie-consent-popup__text">
      <p>
        We use necessary cookies for site functionality and optional cookies for
        analytics, advertising, and site improvement. You can choose to accept
        all cookies or only necessary ones. By using our site, you agree to our
        <a
          href="/terms-of-use"
          target="_blank"
          rel="noopener noreferrer"
          class="cookie-consent-popup__link"
          aria-label="Terms of Use (opens in new window)"
          >Terms of Use</a
        >
        and
        <a
          href="/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          class="cookie-consent-popup__link"
          aria-label="Privacy Policy (opens in new window)"
          >Privacy Policy</a
        >. You can change your preferences anytime in
        <a href="/cookie-settings" class="cookie-consent-popup__link"
          >Cookie Settings</a
        >.
      </p>
    </div>

    <div class="cookie-consent-popup__actions">
      <button
        class="cookie-consent-popup__button cookie-consent-popup__button--decline"
        (click)="declineCookies()"
        type="button"
        aria-label="Reject non-necessary cookies"
      >
        Reject Non-Necessary Cookies
      </button>

      <button
        class="cookie-consent-popup__button cookie-consent-popup__button--accept"
        (click)="acceptCookies()"
        type="button"
        aria-label="Accept all cookies"
      >
        Accept All Cookies
      </button>
    </div>
  </div>
</div>
